// extracted by mini-css-extract-plugin
export default {"mainBox":"GithubCalendar_mainBox__11-t7","para":"GithubCalendar_para__3IXUw","statsBox":"GithubCalendar_statsBox__J2I8d","stats":"GithubCalendar_stats__LOW2H"};